var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divDataPolicyWrapper"}},[_c('VueWrapperNarrow',{style:({
      maxWidth: '80%',
      paddingTop: _vm.isOneTrustPublic ? '0' : '60px',
    })},[(!_vm.isOneTrustPublic)?_c('VueHeadline',{attrs:{"level":"2","weightLevel":"3"}},[_vm._v(_vm._s(_vm.item.header))]):_vm._e(),_c('VueText',{staticClass:"contract-body",style:({
        paddingTop: _vm.isOneTrustPublic ? '0' : '20px',
      }),attrs:{"weightLevel":"2","sizeLevel":"4","color":"grey-40"},domProps:{"innerHTML":_vm._s(_vm.item.text)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }